export default {
	addTransaction: 'ADD_TRANSACTION',
	loading: 'LOADING_TRANSACTION',
	error: 'ERROR_TRANSACTION',
};
